export default [{
  path: '/digital_library/exchange',
  component: () => import('../views/page/digital_library/exchange.vue')
}]
